export default {
    apiKey: "AIzaSyDI1t4AbBQWuT1uH9bT5JkroSdyvA8sp0I",
    authDomain: "later-steve.firebaseapp.com",
    databaseURL: "https://later-steve.firebaseio.com",
    projectId: "later-steve",
    storageBucket: "later-steve.appspot.com",
    messagingSenderId: "985424453749",
    appId: "1:985424453749:web:063a78f09951f36738583c",
    measurementId: "G-QJJ6GCCTSS"
}